import { colombia } from "@pahcertificar/certmanager-locations";

/** All Colombian departments, name-sorted (DANE catalog). */
export const departments = colombia.departments;

/** Municipalities for a department name; [] when the name is unknown. */
export function municipalitiesOf(departmentName: string) {
  return colombia.departments.find((d) => d.name === departmentName)?.municipalities ?? [];
}

/**
 * Keep a department/city pair only if both match the canonical DANE catalog
 * (the city must belong to the department). Anything else collapses to empty,
 * so the location selects never start on a stale, non-selectable value.
 */
export function canonicalLocation(
  department: string,
  city: string
): { department: string; city: string } {
  const dept = colombia.departments.find((d) => d.name === department);
  if (!dept) return { department: "", city: "" };
  const muni = dept.municipalities.find((m) => m.name === city);
  return { department: dept.name, city: muni ? muni.name : "" };
}
